// Routes //////////////////////////////////////////////////////////////////
export const SpecialPackageRoute = (): string => `/special-package`;

// API //////////////////////////////////////////////////////////////////
export const SpecialPackageChartUrl = (startDate?, endDate?): string =>
  `/api/v1/packages/specials/chart_data/${
    startDate ? `?start_date=${startDate}&end_date=${endDate}` : ''
  }`;

export const SpecialPackageDataUrl = (): string => `/api/v1/packages/specials/`;
